const constants = require('@/util/constants')
require('./config')

/**
 * 分页查询待办任务
 */
export function getTodos(page, size, successcb, failedcb) {
    axios.get('/api/todo/query', {
        params: {
            'page': page,
            'size': size,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 创建
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createTodo(title, content, attachments, timestamp, successcb, failedcb) {
    axios.post('/api/todo/create', {
        title,
        content,
        attachments,
        timestamp
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 更新
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateTodo(tid, title, content, attachments, timestamp, successcb, failedcb) {
    axios.post('/api/todo/update', {
        tid,
        title,
        content,
        attachments,
        timestamp
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 删除
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteTodo(id, successcb, failedcb) {
    axios.post('/api/todo/delete', {
        id
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
